import { DefaultButton, dateFormat } from 'design-system';

// Models
import QuotationChange from '../../../../../../models/Quotation/QuotationChange';

// Methods
import { firstStatusChangeDate } from '../../../../../../functions/quotationStatusMethods';

// Components
import BaseHistoryStepCard from '../BaseHistoryStepCard';

const { prettyDateFromServerString } = dateFormat;

type Props = {
  onClick: () => void;
  changes: QuotationChange[];
};

/**
 * The card which provides the navigation capabilities to go to quotation
 * details. It will always be rendered as "completed", as this step doesn't
 * really have a lifecycle (either the quotation exists, or it is not
 * possible to access this card at all).
 */
const DetailsStepCard = ({ onClick, changes }: Props): JSX.Element => {
  const usedDate = firstStatusChangeDate(changes);

  return (
    <BaseHistoryStepCard
      title={
        <>
          Cotización <b>creada</b>
        </>
      }
      subTitle={
        usedDate ? prettyDateFromServerString(usedDate, false) : undefined
      }
      status="completed"
    >
      <DefaultButton
        id="sales-web-button-details"
        data-testid="detailsStepButton"
        variant="outlined"
        fullWidth
        onClick={onClick}
      >
        Ver cotización
      </DefaultButton>
    </BaseHistoryStepCard>
  );
};

export default DetailsStepCard;
